export default "/assets/nutrient-intake-chart-placeholder.png";